<template lang="html">
	<main class="shop" v-if="loaded">
            <div class="link shop-categories-title lundi b-b" @click="mobileMenu = !mobileMenu">
                  Categories <span v-if="!mobileMenu">&darr;</span><span v-else>&uarr;</span>
            </div>
		<div class="shop-categoires flex jc-c lundi" :class="{ 'active b-b': mobileMenu }">
                  <div role="button" class="sli link" @click="changeSort('all')" :class="{ selected: mobileMenu && sortName === 'all' }">
                        Tout LP
                  </div>
                  <div role="button" v-for="category in categories" :key="category" class="sli link" :class="{ selected: mobileMenu && sortName === category }" @click="changeSort(category)">
                        {{ category }}
                  </div>
		</div>
		<div>
		<div v-for="(collection, key) in items" :key="key" class="shop-collection">
				<div class="sli b-b bg-black lundi" :style="{ 'background-color': colors[collection.name] }">{{ collection.name }}</div>
				<div class="shop-container">
					<shop-item
					v-for="item in collection.items"
					:key="item.uid"
					:item="item" />
				</div>
		</div>
		</div>
		<div  v-if="items && items.length < 1" class="li flex jc-c">
			<div class="sli t-c">
				We currently have no {{ sortName }} at the moment. <br /><br />
				Please check back later or subscribe to our newsletter for the latest
				updates.
			</div>
		</div>
	</main>
      <main v-else class="shop"></main>
</template>

<script>
const ShopItem = () => import(/* webpackChunkName: "ShopItem" */ "@/components/ShopItem.vue");
export default {
	components: {
		ShopItem
	},
	data() {
		return {
			sortName: "all",
			mobileMenu: false,
			colors: {},
                  loaded: false,
		};
	},
	created() {
		if (this.$store.state.items.length === 0) {
			this.$store.dispatch("loadProducts").then(()  => {
                        this.loaded = true
                  });
		} else {
                  this.loaded = true;
            }
	},
    mounted() {
        if (this.$route.query.sort) {
            this.changeSort(this.$route.query.sort);
        }
    },
	computed: {
		categories() {
			return this.$store.state.categories;
		},
		raw() {
			return this.$store.state.items.filter(item => item.status == 'listed');
		},
		sorted() {
			const items = this.raw;
			if (this.sortName == "all") {
				return this.raw;
			} else {
				const sorted = items.filter(item => {
                    let category = item.category.map(cat => cat.toLowerCase().replace(/ /g, '-'));
                    return category.includes(this.sortName);
                });
				return sorted;
			}
		},
		items() {
			const grouped = this.groupBy(this.sorted, 'collection');
			let newlist = [];
			Object.keys(grouped).forEach((key) => {
				const newItem = {
					name: key,
					items: grouped[key]
				}
				newlist.push(newItem);
			});
			return newlist;
		},
	},
	methods: {
		groupBy(objectArray) {
			return objectArray.reduce((acc, obj) => {
				const key = obj['collection']['title'];
				this.colors[key] = obj['collection']['color'];
				acc[key] ??= [];
				acc[key].unshift(obj);
				return acc;
			}, {});
		},
		changeSort(sort) {
            let slug = sort.toLowerCase().replace(/ /g, '-');
			// console.log(sort);
			if (this.sortName === slug) {
				this.mobileMenu = true;
			} else {
                this.sortName = slug;
                this.$router.push({ query: { sort: slug } }).catch(()=>{});
				window.scrollTo(0, 0);
				this.mobileMenu = false;
			}
		}
	}
};
</script>

	<style lang="scss" scoped>
      .shop {
            @media only screen and (max-width:768px) {
                  padding-top: calc(4 * var(--lh) + 1px) !important;
            }
      }
	.bg-black {
            background:var(--orange);
            margin-top: var(--lh);
            border-top:1px solid black;
            color: white;
            text-transform:uppercase;
            text-align: center;
	}
	.shop-collection:first-of-type .bg-black {
            border-top:0;
            margin-top:0;
	}
	.shop-container {
            width: 100%;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-gap: var(--lh);
            @media only screen and (max-width: 1280px) {
                  grid-template-columns: repeat(4, 1fr);
            }
            @media only screen and (max-width: 1024px) {
                  grid-template-columns: 1fr 1fr;
            }
	}
      .shop-categories-title {
            display: none;
            @media only screen and (max-width: 768px) {
                  position: fixed !important;
                  top: calc(2 * var(--lh) + 1px);
                  background:white;
                  border-right:0;
                  left:0;
                  width:100%;
                  padding: var(--pad);

                  display:block;
                  z-index:88;
            }
      }
	.shop-categoires {
            border-bottom:1px solid black;
            @media only screen and (max-width: 768px) {
                  background: white;
                  position: fixed;
                  width:100%;
                  top: calc(4 * var(--lh) + 1px);
                  left: 0;
                  z-index: 8;
                  flex-direction: column;
                  .sli {
                        border-right: 0 !important;
                        border-bottom: 1px solid black;
                        display: none !important;
                        &:last-of-type {
                              border-bottom: 0;
                        }
                        order: 1;
                        &.selected {
                              // color: r;
                              order: 0;
                              border-bottom: 0;
                              display: flex !important;
                        }
                        }
                        &.active {
                              .sli {
                                    display: flex !important;
                                    order: 0;
                                    &.selected {
                                          border-bottom: 1px solid black;
                                    }
                              }
                  }
            }
	}
</style>
